import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent, IconShape } from '@copado/cds';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'app-placeholder',
  styleUrl: './placeholder.component.scss',
  templateUrl: './placeholder.component.html',
})
export class PlaceholderComponent {
  title = input.required<string>();
  icon = input.required<IconShape>();
}
